import React from 'react';
import { Button } from 'reactstrap';
export default function CustomEditButton(props){  
    const {keyvalue} = props;  
    return(
        <Button
            type="button"
            className='action-btn'
            color='info'
            id={`tooltip_edit_key_${keyvalue}`}
            title="Edit"
            aria-label="Edit"
            {...props}
        >
            <span className='fas fa-pencil-alt'></span>
        </Button>
    );
}
